import { Matomo } from './Matomo';
import { isBackendUserLoggedIn } from '@commons/_utils';

const matomoConfig = document.querySelector('script#matomo-config');
if (matomoConfig) {
    const config = JSON.parse(matomoConfig.innerHTML) || null;

    if (!await isBackendUserLoggedIn() && config !== null) {
        new Matomo(config);
    }
}
